export const mapTankTypes = {
    "Fuel": ["0"],
    "Oil": ["4"],
    "Sewage": ["2", "5"],
    "Water": ["1", "3"],
    "Others": ["6", "7", "8", "9", "10", "11", null],
}

export const mapGeneratorStates = {
    "Stopped": ["0"],
    "Manual": ["1", "2"],
    "Auto": ["3", "4", "5", "6", "7", "8", "9", "10"]
};